// extracted by mini-css-extract-plugin
module.exports = {"bottom_menu":"BottomMenu_bottom_menu__3jffl","menu_item":"BottomMenu_menu_item__3q2rv","menu_item_selected":"BottomMenu_menu_item_selected__3Jm2b"};